








































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class Home extends Vue {
  public sumIndex = 0;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  public list;
  @Watch("list")
  public change() {
    this.sumIndex = 0;
  }
  public clickRight() {
    if (this.sumIndex + 1 <= this.list.length - 4) {
      this.sumIndex += 3;
    }
  }
  public clickLeft() {
    if (this.sumIndex >= 3) {
      this.sumIndex -= 3;
    }
  }
}
